import { ViewConfig } from "@lib/views";
import { TransactionCategoryColumn } from "@common/types/views/transactionCategoriesView";
import { TransactionCategoryRow } from "./viewUtils";
import { NameCell } from "./Cells/NameCell";
import { DescriptionCell } from "./Cells/DescriptionCell";
import { GlMappingCell } from "./Cells/GlMappingCell";
import { PercentageCell } from "./Cells/PercentageCell";
import { TransactionsCell } from "./Cells/TransactionsCell";
import { ActionsCell } from "./Cells/ActionsCell";

export const createCategoriesViewConfig = (): ViewConfig<
    TransactionCategoryRow,
    TransactionCategoryColumn,
    never
> => ({
    columns: {
        [TransactionCategoryColumn.NAME]: {
            accessorKey: "label",
            name: "Transaction category",
            header: "Transaction category",
            immutable: true,
            cell: NameCell,
            minSize: 200,
            maxSize: 600,
        },
        [TransactionCategoryColumn.DESCRIPTION]: {
            accessorKey: "description",
            name: "Category description",
            header: "Category description",
            cell: DescriptionCell,
            minSize: 200,
            maxSize: 800,
        },
        [TransactionCategoryColumn.GL_MAPPING]: {
            accessorKey: "glMapping",
            name: "GL mapping",
            header: "GL mapping",
            cell: GlMappingCell,
            hiddenFromSettings: true,
            minSize: 200,
            maxSize: 400,
        },
        [TransactionCategoryColumn.PERCENTAGE]: {
            accessorKey: "percentage",
            name: "%",
            header: "%",
            cell: PercentageCell,
            minSize: 80,
            maxSize: 100,
        },
        [TransactionCategoryColumn.TRANSACTIONS]: {
            accessorKey: "transactionsCount",
            name: "Transactions",
            header: "Transactions",
            cell: TransactionsCell,
            minSize: 100,
            maxSize: 140,
        },
        [TransactionCategoryColumn.ACTIONS]: {
            accessorKey: "id",
            name: "Actions",
            header: "",
            immutable: true,
            hiddenFromSettings: true,
            cell: ActionsCell,
            minSize: 60,
            maxSize: 60,
        },
    },
    nesting: {
        enabled: true,
        expandColumn: TransactionCategoryColumn.NAME,
        childrenKey: "children",
    },
});
